export default "__VITE_ASSET__B35b97s3__"